import React from "react";

function TicketManagementConfirmationContact({ data }) {
  if (!data) return null;

  const name = data?.contactName || "-";
  const email = data?.contactEmail || "-";
  const phone = data?.contactPhone || "-";

  return (
    <div className="w-full mt-4 flex flex-col gap-4">
      <span className="font-bold text-xl">Contact</span>

      <div className="w-full rounded-lg bg-white p-3 sm:p-4 border border-gray-200">
        {/* Header row (desktop only) */}
        <div className="hidden sm:grid grid-cols-3 gap-6 text-xs text-gray-500 mb-2">
          <div>Name</div>
          <div>E-mail</div>
          <div>Phone no</div>
        </div>

        {/* Data row (desktop grid; mobile shows label/value blocks) */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 items-start text-sm">
          {/* Name */}
          <div className="flex flex-col">
            <span className="text-xs text-gray-500 sm:hidden mb-0.5">Name</span>
            <span className="text-gray-900">{name}</span>
          </div>

          {/* Email */}
          <div className="flex flex-col break-all">
            <span className="text-xs text-gray-500 sm:hidden mb-0.5">
              E-mail
            </span>
            {email !== "-" ? (
              <a
                href={`mailto:${email}`}
                className="text-gray-900 hover:underline"
              >
                {email}
              </a>
            ) : (
              <span className="text-gray-900">-</span>
            )}
          </div>

          {/* Phone */}
          <div className="flex flex-col">
            <span className="text-xs text-gray-500 sm:hidden mb-0.5">
              Phone no
            </span>
            {phone !== "-" ? (
              <a
                href={`tel:${phone.replace(/\s+/g, "")}`}
                className="text-gray-900 whitespace-nowrap"
              >
                {phone}
              </a>
            ) : (
              <span className="text-gray-900">-</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TicketManagementConfirmationContact;
